module.exports = __webpack_public_path__ + "assets/images/project/people/girl.svg?v=ec57b20e";